import { Pipe, PipeTransform } from "@angular/core";
import { platforms } from "app/core/apps/model/app";
@Pipe({
  name: "appPlatform",
})
export class AppPlatformPipe implements PipeTransform {
  transform(platform: any, args?: any): any {
    let result = Object.keys(platforms).find(
      (key) => platforms[key] === platform
    );
    return result;
  }
}
